import { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  useNavigate,
  useOutletContext,
  useRouteLoaderData,
} from "react-router-dom";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import {
  DateFormater,
  handleSessionOut,
  Loader,
} from "../../../../HelperFunctions/HelperFunctions";
import { merchatCorpDetais, reconciliationDetails } from "../../../../API/backendAPI";
import { enqueueSnackbar } from "notistack";
import ImportDialog from "./ImportDialog/ImportDialog";
import MerchantReconciliationDialog from "./ReconciliationDialog/MerchantReconciliationDialog";
import DsCardsTable from "../../../../HelperFunctions/DsCardsTable";
import ArrowDownIcon from "@rsuite/icons/ArrowDown";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { userSecurity } from "../../../../API/nimbleAPI";
import SecurityLockDialog from "./SecurityLockDialog/SecurityLockDialog";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const DsCards = () => {
  const {
    selectedCorp,
    setSelectedCorp,
    setMerchantProvider,
    date,
    setDate,
    restartSSE,
    setRestartSSE
  } = useOutletContext();
  const {
    corporations,
    headerCorporation,
    userId,
    clientId,
    Previlage,
    userPreference,
    merchantName,
  } = useRouteLoaderData("reconciliation");

  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [defaultDateRange, setDefaultDateRange] = useState({});
  const [gridCorp, setGridCorp] = useState(null);
  const [openSecurityDialog, setOpenSecurityDialog] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [pcid, setPcid] = useState(null);
  const [pcName, setPcName] = useState(null);
  const [bankID, setbankID] = useState(null);

  useEffect(() => {
    if (merchantName && merchantName !== "0") {
      getEachMerchantDetails();
    }
  }, []);

  const getEachMerchantDetails = async () => {
    setLoading(true);
    try {

      const payload = {
        corp_id: headerCorporation,
        merchant: merchantName
      };

      const merchantDetails = await merchatCorpDetais(payload);
      const row = await merchantDetails
      if (row && row.multi_bank) {
        setLoading(false);
        return;
      }
      return await getReconciliationDetails(clientId, headerCorporation, row)

    } catch (error) {
      enqueueSnackbar("Error while Get Merchant Details", { variant: "error" })
    } finally {
      setLoading(false);
    }

  };


  const navigate = useNavigate();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // const yesterday = new Date(today);
  // yesterday.setDate(today.getDate() - 1);

  const handleCellClick = async (corporation_id, row, column) => {
    if (column === "chargebacks") {
      navigate("../chargebacks", {
        replace: true,
        state: {
          pcid: row.pc_id,
          bankAccountId: row.bank_account_id,
          corporationId: corporation_id,
        },
      });
      setMerchantProvider(row.merchant_provider);
      setPcid(row.pc_id);
    } else {
      await getReconciliationDetails(clientId, corporation_id, row);
    }
  };

  const getReconciliationDetails = async (client_id, corp_id, row) => {

    // console.log("rowwwwwwwwwwwwwwwwwwwwwwwww",row)
    // const pcID = localStorage.getItem("pc_id");

    setPcid(row.pc_id);
    setPcName(row.pc_name);
    setbankID(row.bank_account_id)

    setLoading(true);

    const { from_date, to_date, pc_id, bank_account_id } = row;
    try {
      const payload = {
        bank_account_id: bank_account_id || "",
        pc_id: pc_id || "",
        client_id,
        user_id: userId,
        corp_id,
        from_date: DateFormater(new Date(from_date)),
        to_date: DateFormater(new Date(to_date)),
        merchant_provider: row?.merchant_provider || "",

      };
      const data = await reconciliationDetails(payload);
      setDefaultDateRange({ fromDate: from_date, toDate: to_date });
      setGridCorp(corp_id);
      setMerchantDetails(data);
    } catch {
      enqueueSnackbar("Error while getting ReconciliationDetails", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: (option) => option.Name,
  });

  return (
    <>
      <Stack height="100%" gap={2}>
        <Stack
          justifyContent="space-between"
          direction="row"
          alignItems="flex-end"
        >
          <Stack direction="row" spacing={2} flexGrow={1} alignItems="flex-end">
            <Autocomplete
              options={corporations}
              size="small"
              disableClearable
              // getOptionLabel={(option) => option.Name}
              getOptionLabel={(option) =>
                userPreference?.IsShowCorpLegalName
                  ? option.LegalName
                  : option.Name
              }
              isOptionEqualToValue={(option, value) => option.ID === value.ID}
              value={selectedCorp}
              onChange={(event, newValue) => setSelectedCorp(newValue)}
              filterOptions={filterOptions}
              noOptionsText="No corporations Found"
              componentsProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-noOptions": {
                      fontSize: "12px",
                    },
                  },
                },
              }}
              sx={{ maxWidth: "280px", flexGrow: 1 }}
              renderInput={(params) => (
                <TextField {...params} label="Corporation" variant="filled" />
              )}
            />
            <Stack>
              <Typography fontSize="10px" color="#7b7b7b">
                As of date
              </Typography>
              <DatePicker
                value={date}
                // onChange={setDate}
                onChange={(value) => {
                  if (value === null) {
                    setDate((prev) => new Date(prev.getTime() + 1));
                  } else {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const selectedDate = new Date(value);
                    selectedDate.setHours(0, 0, 0, 0);

                    if (selectedDate > today) {
                      return;
                    }
                    setDate(value);
                  }
                }}
                oneTap
                ranges={[
                  {
                    label: "Today",
                    value: today,
                  },
                  // {
                  //   label: "Yesterday",
                  //   value: yesterday,
                  // },
                  {
                    label: "Clear",
                    value: null,
                  },
                ]}
                format="MM/dd/yyyy"
                cleanable={false}
                disabledDate={(date) => date > new Date()}
                caretAs={() => <ArrowDownIcon style={{ fontSize: 20 }} />}
              />
            </Stack>

          </Stack>

          <Button
            disableElevation
            variant="contained"
            color="black"
            sx={{ backgroundColor: "#e8e8e8", textTransform: "none", px: 3 }}
            startIcon={<SystemUpdateAltIcon sx={{ mr: 1.5 }} />}
            onClick={async () => {
              if (!Previlage?.[0]?.Create) {
                enqueueSnackbar("You do not have permission to import files.", {
                  variant: "error",
                });
                return;
              }
              if (selectedCorp.ID === "select") {
                enqueueSnackbar(
                  "Corporation must be selected to import the files",
                  { variant: "warning" },
                );
                return;
              }

              try {
                const payload = {
                  corpID: selectedCorp?.ID,
                  booksDate: dayjs()
                    .utc()
                    .startOf("day")
                    .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
                  type: 20,
                };

                const security = await userSecurity(payload);
                if (security?.status === 401 || security?.StatusCode === 401) {
                  handleSessionOut();
                  return;
                }

                if (security) {
                  setOpenSecurityDialog(true);
                  return;
                }

                // Open dialog
                setOpenImportDialog(true);
              } catch (error) {
                console.error(error);
                enqueueSnackbar("Failed to check security status.", {
                  variant: "error",
                });
              }
            }}
          >
            Import
          </Button>
        </Stack>

        <DsCardsTable
          date={date}
          onCellClick={handleCellClick}
          setLoading={setLoading}
          merchantDetails={merchantDetails}
          userPreference={userPreference}
        />
      </Stack>

      {useMemo(() => {
        return openImportDialog ? (
          <ImportDialog
            open={openImportDialog}
            onClose={() => setOpenImportDialog(false)}
            corp={selectedCorp}
            userPreference={userPreference}
            setImportLoading={setImportLoading}
            setRestartSSE={setRestartSSE}
          />
        ) : null;
      }, [openImportDialog])}

      <SecurityLockDialog
        open={openSecurityDialog}
        CorpID={selectedCorp}
        onClose={() => setOpenSecurityDialog(false)}
        onSuccess={() => {
          setOpenSecurityDialog(false);
          setOpenImportDialog(true);
        }}
      />

      {merchantDetails && (
        <MerchantReconciliationDialog
          open={Boolean(merchantDetails)}
          onClose={() => setMerchantDetails(null)}
          gridCorp={gridCorp}
          merchantDetails={merchantDetails}
          setMerchantDetails={setMerchantDetails}
          defaultDateRange={defaultDateRange}
          userPreference={userPreference}
          pcid={pcid}
          setPcid={setPcid}
          pcName={pcName}
          bankId={bankID}
        />
      )}

      {loading && <Loader loading={loading} />}
      {importLoading && <Loader />}
    </>
  );
};

export default DsCards;
